export enum PageType {
  BRANCH = 'BRANCH',
  STORE = 'STORE',
  BRAND_ALL = 'BRAND_ALL',
  BRANCH_NEWS_DETAIL = 'BRANCH_NEWS_DETAIL',
  STORE_NEWS_DETAIL = 'STORE_NEWS_DETAIL',
  DESIGNER_NEWS_DETAIL = 'DESIGNER_NEWS_DETAIL',
  EVENT = 'EVENT',
  EVENT_DETAIL = 'EVENT_DETAIL',
  RELATION_PRODUCT_DETAIL = 'RELATION_PRODUCT_DETAIL',
  PRODUCT_DETAIL = 'PRODUCT_DETAIL',
  POPUP = 'POPUP',
  REVIEW = 'REVIEW',
  NEWS = 'NEWS',
}
